import React from "react";
import logo from "../../assets/UnderDevImg.png";


export default function UnderDevelopmentPage() {
  // Primary color
  const primaryColor = "#003366";

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white p-4">
      {/* Image */}
      <div className="mb-8 max-w-xl">
        <img 
          src={logo} 
          alt="Data analytics dashboard with team members collaborating" 
          className="w-full h-auto"
        />
      </div>
      
      {/* Text content */}
      <h1 
        className="text-3xl font-bold mb-4 text-center" 
        style={{ color: primaryColor }}
      >
        Under Development
      </h1>
      
      <p className="text-xl text-slate-600 text-center max-w-md">
        We're working hard to bring you this feature soon. Please check back later.
      </p>
    </div>
  );
}
